import React from 'react';
import { Image, ImageOverlay, StudyPlanButton, SvgIcon } from 'seduo-ui';
const Example = () => (<div className="card card-course h-100 shadow-sm" style={{
        maxWidth: '258px',
    }}>
        <ImageOverlay className="card-course__image-wrapper" topRight={<StudyPlanButton onAddToStudyPlan={() => { }} onRemoveFromStudyPlan={() => { }} title="Add to study plan"/>}>
            <a href="#" title="Bla bla">
                <Image src="https://dummyimage.com/520x350/9fa4a8/fff.png" alt="Bla bla" className="card-course__image"/>
            </a>
        </ImageOverlay>
        <div className="card-body card-course__body">
            <a className="card-course__title font-weight-medium" href="#">
                Another only one line text
            </a>
            <div className="card-course__subtitle card-course__subtitle--standalone">
                <a className="link card-course__link" href="#">
                    Name Surname
                </a>
            </div>
            <div className="card-course__subtitle card-course__subtitle--bottom">
                <div className="card-course__text">
                    <span className="card-course__dote card-course__dote--brand-orange mr-5"/>
                    <span className="text-title">Vystudujte do 21. 3. 2021</span>
                </div>
            </div>
        </div>
        <div className="card-course__footer">
            <a href="#">
                <div className="card-course__subtitle card-course__subtitle--standalone">
                    <span className="link card-course__link">8/12 lekcí dokončeno</span>
                    <SvgIcon kind="ArrowRight" className="card-course__icon card-course__icon--small card-course__icon--success"/>
                </div>
                <div className="card-course__subtitle d-block">
                    <div className="progress progress--small">
                        <div className="progress-bar" role="progressbar" aria-valuenow={66} aria-valuemin={0} aria-valuemax={100} style={{
        width: '66%',
    }}>
                            {' '}
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>);
export default Example;
